var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16",
    width: 18,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bath-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ff385c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m16.5 5.8h-11.7v-2.5c0-0.9 0.8-1.6 1.7-1.6 0.9 0 1.7 0.7 1.7 1.6h1.6c0-1.8-1.5-3.3-3.3-3.3-1.8 0-3.3 1.5-3.3 3.3v2.5h-1.7q-0.3 0-0.6 0.3-0.2 0.2-0.2 0.6v1.6c0 2.2 1.4 4.1 3.3 4.7v2.8h1.7v-2.5h6.6v2.5h1.7v-2.8c1.9-0.6 3.3-2.5 3.3-4.7v-1.6q0-0.4-0.2-0.6-0.3-0.3-0.6-0.3zm-0.8 2.5c0 1.9-1.5 3.4-3.4 3.4h-6.6c-1.9 0-3.4-1.5-3.4-3.4v-0.8h13.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathIcon);
export default __webpack_public_path__ + "static/media/bath-icon.713a995d83a76aaee6e4b771fc602263.svg";
export { ForwardRef as ReactComponent };